import React from 'react';
import List from 'containers/rest/List';
import RestFieldItem from 'components/RestField/RestFieldItem';
import ActionGroup from 'components/RestActions/ActionGroup';
import EditButton from 'components/RestActions/EditButton';
import DeleteButton from 'components/RestActions/DeleteButton';

const SalaryStepsList = props => (
  <List {...props} resource="salarySteps">
    <RestFieldItem source="name" header="salarySteps.name" />
    <RestFieldItem source="description" header="salarySteps.description" />
    <RestFieldItem source="priority" header="salarySteps.priority" />
    <RestFieldItem source="isActive" header="salarySteps.isActive" />
    <ActionGroup>
      <EditButton />
      <DeleteButton />
    </ActionGroup>
  </List>
);

SalaryStepsList.propTypes = {};

export default SalaryStepsList;
